import React from 'react';
import { CheckIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-100" data-mp="1cl62j9n0rkh2">
      <div className="mx-auto w-full max-w-4xl" data-id="element-101" data-mp="1clpiikt3zysg">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-102" data-mp="18juidjmwzrg9">
          🎁 Además recibirás estos 5 Bonos Exclusivos
        </h2>
        <p className="mt-3 text-center text-sm font-bold uppercase tracking-widest text-accent sm:text-base" data-id="element-103" data-mp="20b0ezq3ff70s">
          Incluidos sin costo adicional
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy-800/80 sm:text-lg" data-id="element-104" data-mp="1w7c8laqj6hh4">
          Porque dominar el hipotiroidismo no depende únicamente de conocer la
          teoría. También necesitas herramientas que agilicen tus decisiones
          durante la consulta.
        </p>

        <ul className="mt-10 space-y-5" data-id="element-105" data-mp="fx9tcptwvrfv">
          {bonuses.map(bonus => <li key={bonus.number} className="overflow-hidden rounded-3xl border border-navy-100 bg-navy-50/50" data-id="element-106" data-mp="1eug88hf0kmrq">
              <div className="flex items-center gap-3 bg-navy-900 px-5 py-3" data-id="element-107" data-mp="15truzoxg2qfw">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent font-display text-base font-black text-white" data-id="element-108" data-mp="1arte29uveprd">
                  {bonus.number}
                </span>
                <span className="text-xs font-extrabold uppercase tracking-widest text-navy-200" data-id="element-109" data-mp="10uf9b7ib7pew">
                  🎁 Bono #{bonus.number}
                </span>
              </div>

              <div className="bg-white px-3 pt-4 sm:px-6 sm:pt-6" data-id="element-110" data-mp="r42gks0ccpxo">
                <img src={bonus.image} alt={`Mockup del Bono ${bonus.number}: ${bonus.title}`} loading="lazy" className="mx-auto w-full max-w-xl" data-id="element-111" data-mp="r4c5ec9ngr1s" />
              </div>

              <div className="p-5 sm:p-6" data-id="element-112" data-mp="2jsto4cic00r9">
                <h3 className="font-display text-[19px] font-black leading-snug text-navy-950 sm:text-2xl" data-id="element-113" data-mp="2jtv0ckb32tak">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-navy-800/80 sm:text-base" data-id="element-114" data-mp="2azgjidawnapc">
                  {bonus.intro}
                </p>

                <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-115" data-mp="25z2fd6cfckwl">
                  {bonus.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-116" data-mp="2ypugmi8cjzqs">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-600" aria-hidden="true" data-id="element-117" data-mp="2yqlzqtkrc506" />
                      <span className="text-[14px] font-medium text-navy-900 sm:text-[15px]" data-id="element-118" data-mp="2oqv5mt03zs0m">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <p className="mt-4 text-[14px] font-semibold italic leading-relaxed text-navy-800 sm:text-base" data-id="element-119" data-mp="1db6ia0iy0qza">
                  {bonus.outro}
                </p>

                <p className="mt-4 inline-flex rounded-full bg-white px-4 py-1.5 text-sm font-extrabold text-accent shadow-sm" data-id="element-120" data-mp="186ujayaaa6m8">
                  Valor: {bonus.value}
                </p>
              </div>
            </li>)}
        </ul>

        <TransformCTA headline="Suma 5 herramientas que resuelven la consulta antes de que el paciente se siente." data-id="element-121" data-mp="1hzjwpype9uk7" />
      </div>
    </section>;
}